// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/credit.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file api_proto/v1/credit.proto.
 */
export const file_api_proto_v1_credit: GenFile = /*@__PURE__*/
  fileDesc("ChlhcGlfcHJvdG8vdjEvY3JlZGl0LnByb3RvEgxhcGlfcHJvdG8udjEqegoMQ3JlZGl0U291cmNlEh0KGUNSRURJVF9TT1VSQ0VfVU5TUEVDSUZJRUQQABIWChJDUkVESVRfU09VUkNFX05PTkUQARIXChNDUkVESVRfU09VUkNFX1RSSUFMEAISGgoWQ1JFRElUX1NPVVJDRV9DT05UUkFDVBADQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw");

/**
 * AI機能の課金元種別（plan-restructure-2026-10 R6 tasks 6.6）
 * 設計の経緯: openspec/changes/archive/2026-10-07-plan-restructure-2026-10/design-6.6-notifications.md §2
 *
 * AI機能実行のレスポンスに載せ、フロントのGA4計測（gaLabel）が無料体験消費/契約消費を
 * 区別できるようにする。credit_type / grant_source 等の台帳内部表現は
 * admin_credit.proto / plan_status.proto の方針どおり string で持つが、
 * 本フィールドは計測用途の粗い3値分類（未課金/体験/契約）に閉じるため enum で定義する。
 *
 * go/logic/credit.GrantSource（体験ロットかどうかの判定）・
 * go/company_usecase.CreditTicket.TrialUsed が値の SSOT。
 *
 * @generated from enum api_proto.v1.CreditSource
 */
export enum CreditSource {
  /**
   * 未指定（後方互換のデフォルト値）
   *
   * @generated from enum value: CREDIT_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * クレジット制御が無効（NoOpチケット）、または記録モードで実際には課金されていない
   *
   * @generated from enum value: CREDIT_SOURCE_NONE = 1;
   */
  NONE = 1,

  /**
   * 無料体験ロット（grant_source=trial）から充当された
   *
   * @generated from enum value: CREDIT_SOURCE_TRIAL = 2;
   */
  TRIAL = 2,

  /**
   * 契約付与ロットから充当された
   *
   * @generated from enum value: CREDIT_SOURCE_CONTRACT = 3;
   */
  CONTRACT = 3,
}

/**
 * Describes the enum api_proto.v1.CreditSource.
 */
export const CreditSourceSchema: GenEnum<CreditSource> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_credit, 0);

